import { Box, Button, Typography } from "@material-ui/core";
import SelectField from "Components/formControls/HookFields/SelectField";
import GridSkeleton from "Components/SkeletonLoader/GridSkeleton";
import React, { Fragment, useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { checkinSRSDetailsState } from "Recoil/Targets/atom";
import FeedbackGrid from "../FeedbackGrid";
import { useStyles } from "./styles";
import ExpandIcon from "Assets/images/expand.svg";
import CollapseIcon from "Assets/images/collapse.svg";
import DetailsGridView from "Modules/Checkins/Overview/RightPanel/DetailsGridView";
import { useCheckinDetailGrid } from "Hooks/checkin/useCheckinDetailGrid";
import { checkinDetailsExpandState } from "Recoil/Checkins/atom";
import { useHistory } from "react-router";

const SkillQuestions = ({
  selectedSkillName,
  setSortSelected,
  sortSelected,
  skillRatee,
  selectedFrequency,
}) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useRecoilState(checkinDetailsExpandState);
  const history = useHistory();
  const [columnsState, setColumnsState] = useState([]);
  const { ratingResponse, loading } = useRecoilValue(checkinSRSDetailsState);
  const [sortOptions] = useState([
    { name: "Group by rater" },
    { name: "Group by question" },
  ]);
  useEffect(() => {
    setSortSelected("Group by rater");
  }, []);
  const [checkinDetailsSRS, setCheckinDetailsSRS] = useState([]);
  const {
    surveyDetailsColumns,
    fetchSurveyDetailsColumns,
    formatSurveyQuestionWise,
    formatSurveyPeopleWise,
  } = useCheckinDetailGrid();

  useEffect(() => {
    setCheckinDetailsSRS(ratingResponse);
  }, [ratingResponse]);

  useEffect(() => {
    if (sortSelected === "Group by question") {
      setCheckinDetailsSRS(
        formatSurveyQuestionWise(ratingResponse?.groupByQuestions)
      );
    } else {
      setCheckinDetailsSRS(
        formatSurveyPeopleWise({
          userCheckinData: ratingResponse?.groupByRaters?.map((res) => ({
            ...res,
            checkInStatus: res?.status || "COMPLETED",
          })),
        })
      );
    }
  }, [ratingResponse, sortSelected]);
  
  useEffect(() => {
    if (
      history?.location?.state?.respondedUserId &&
      checkinDetailsSRS?.length > 0
    ) {
      
      let data = checkinDetailsSRS.slice();
      let index = data.findIndex(
        (d) => d.id === history?.location?.state?.respondedUserId
      );
      if (index >= 0)
        data[index] = {
          ...data[index],
          expanded: true,
        };
      setCheckinDetailsSRS(data);
    }
  }, [history?.location?.state?.respondedUserId, , checkinDetailsSRS?.length]);

  // useEffect(() => {
  //   return () => setExpanded(false);
  // }, []);

  useEffect(() => {
    if (sortSelected === "Group by question") {
      const columns = surveyDetailsColumns.filter((c) =>
        ["title"].includes(c.field)
      );
      setColumnsState(columns);
    } else {
      const columns = surveyDetailsColumns.filter((c) =>
        ["name", "dueDate", "status", "score"].includes(c.field)
      );
      setColumnsState(columns);
    }

    // setExpanded(false);
  }, [sortSelected, selectedFrequency]);

  const expandAll = () => {
    const data = checkinDetailsSRS.map((res) => ({
      ...res,
      expanded: !expanded,
    }));
    setCheckinDetailsSRS(data);
    setExpanded((res) => !res);
  };

  return (
    <Fragment>
      {loading ? (
        <Box mt={2}>
          <GridSkeleton />
        </Box>
      ) : sortSelected ? (
        <Box className={classes.srsGridView}>
          <Box
            mt={3}
            className="qus-filter"
            display="flex"
            justifyContent={"space-between"}
            alignItems="center"
          >
            <Box width="180px" className={classes.sortSelect}>
              <SelectField
                defaultValue={sortSelected}
                options={sortOptions}
                onChange={(e) => setSortSelected(e.target.value)}
                value={sortSelected}
              />
            </Box>
            <Button
              size="small"
              color="primary"
              className="mr10"
              onClick={expandAll}
              data-testid="ExpandedBtn"
            >
              {/* Expand all */}
              {expanded ? "Collapse all" : "Expand all"}
              <img
                src={expanded ? CollapseIcon : ExpandIcon}
                alt="expand all"
                width="20px"
                className="ml5"
              />
            </Button>
          </Box>
          <Box mt={3}>
            <Typography className={classes.ratingTxt}>
              The 10 behaviors rated for this skill are listed below for{" "}
              <b>{selectedSkillName}</b>
            </Typography>
          </Box>
          <Box
            className={
              sortSelected == "Group by question" ? classes.srsQusView : ""
            }
          >
            <DetailsGridView
              // loader={loader}
              setExpand={setExpanded}
              sortSelected={sortSelected}
              columnsState={columnsState}
              checkinData={checkinDetailsSRS}
              checkInType={"SKILLRATING"}
              fetchColumn={fetchSurveyDetailsColumns}
              surveyResponseData={checkinDetailsSRS}
              setSurveyResponseData={setCheckinDetailsSRS}
            />
            {sortSelected == "Group by question" ? (
              <FeedbackGrid skillRatee={skillRatee} />
            ) : null}
          </Box>
        </Box>
      ) : null}
    </Fragment>
  );
};

export default SkillQuestions;
